<script setup lang="ts">
defineProps<{
  gesture: 'one-finger' | 'two-fingers' | 'pinch'
}>()
</script>

<template>
  <svg class="touch-glyph" viewBox="0 0 22 24" width="22" height="24" aria-hidden="true">
    <template v-if="gesture === 'one-finger'">
      <circle cx="11" cy="8.5" r="5.5" class="touch-glyph__line" />
      <circle cx="11" cy="8.5" r="3" class="touch-glyph__finger" />
      <path
        d="M4.5 17.5Q11 22.5 17.5 17.5M14.8 17.2L17.5 17.5L17.1 20.2"
        class="touch-glyph__line"
      />
    </template>
    <template v-else-if="gesture === 'two-fingers'">
      <circle cx="6" cy="8.5" r="4" class="touch-glyph__line" />
      <circle cx="16" cy="8.5" r="4" class="touch-glyph__line" />
      <circle cx="6" cy="8.5" r="2.25" class="touch-glyph__finger" />
      <circle cx="16" cy="8.5" r="2.25" class="touch-glyph__finger" />
      <path d="M4 19H18M15.5 16.5L18 19L15.5 21.5" class="touch-glyph__line" />
    </template>
    <template v-else>
      <path d="M8 16L3 21M3 17.5V21H6.5M14 8L19 3M15.5 3H19V6.5" class="touch-glyph__line" />
      <circle cx="9" cy="15" r="2.75" class="touch-glyph__finger" />
      <circle cx="13" cy="9" r="2.75" class="touch-glyph__finger" />
    </template>
  </svg>
</template>

<style scoped>
.touch-glyph {
  flex-shrink: 0;
}

.touch-glyph__line {
  fill: none;
  stroke: rgba(0, 0, 0, 0.55);
  stroke-width: 1.3;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.touch-glyph__finger {
  fill: rgb(var(--v-theme-primary));
}
</style>
